<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <h4 class="card-title">Pages List</h4>
          <div class="d-flex justify-content-start">
            <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['content-pages/create'])"
                         :to="'/content-pages/create'"
                         class="btn btn-info btn-wd" wide>
              Add New
              <span class="btn-label">
                    <i class="fa fa-plus"></i>
                </span>
            </router-link>


          </div>


        </div>

        <!--    filters    -->
        <div class="row col-12 mb-2">
          <div class="col-md-4 col-sm-4">
            <fg-select
              size="large"
              filterable
              clearable
              placeholder="Select Page"
              :input-classes="'select-default'"
              :list="filterBuilders.pages"
              :listItemLabel="'label'"
              :listItemValue="'id'"
              v-model="filters.page_id">
            </fg-select>
          </div>

          <div class="col-md-2 col-sm-4">
            <l-button class="mr-lg-1" @click="applyFilter()" type="info">Filter Result</l-button>
          </div>
        </div>
        <!--  end  filters    -->

        <div>
          <general-data-table
            ref="table"
            :method="'POST'"
            :row-key="'id'"
            :key="componentKey"
            @reorder="reorder($event)"
            :api-url="'pages/index'">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :align="column.align"
                             :prop="column.value"
                             :sortable="column.sortable"
                             :label="column.label">
            </el-table-column>

            <el-table-column
              :min-width="120"
              :fixed="fixedColumn"
              align="center"
              label="Actions">
              <template slot-scope="scope">

                <template v-if="scope.row.page_type === 'CONTENT_PAGE'">
                  <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['content-pages/update'])"
                               v-tooltip.top-center="'Edit'"
                               class="btn-warning btn-simple btn-link"
                               :to="'/content-pages/edit/'+scope.row.id">
                    <i class="fa fa-edit"></i>
                  </router-link>
                </template>

                <template v-if="scope.row.page_type === 'REDIRECTION_PAGE'">
                  <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['redirection-pages/update'])"
                               v-tooltip.top-center="'Edit'"
                               class="btn-warning btn-simple btn-link"
                               :to="'/redirection-pages/edit/'+scope.row.id">
                    <i class="fa fa-edit"></i>
                  </router-link>
                </template>


                <a v-if="$store.getters['auth/haveOneOfPermissions'](['pages/delete'])"
                   v-tooltip.top-center="'Delete'"
                   class="btn-danger btn-simple btn-link"
                   @click="openDeleteModal(scope.row.id)">
                  <i class="fa fa-times"></i></a>
              </template>

            </el-table-column>
          </general-data-table>
        </div>

      </card>
      <delete-modal :visible="deleteModalVisibility"
                    :message="'Are you sure you want to delete this page?'"
                    @close="closeDeleteModal()"
                    @confirm="confirmDeleteModal()">
      </delete-modal>

    </div>
  </div>
</template>

<script>
import {DeleteModal as DeleteModal} from '@/components'
import GeneralDataTable from "@/components/GeneralDataTable";
import {TableColumn} from "element-ui";
import FgSelect from "@/components/Inputs/formGroupSelect";
import ExportModal from '@/components/ExportModal/ExportModal.vue';


export default {
  components: {
    GeneralDataTable,
    DeleteModal,
    [TableColumn.name]: TableColumn,
    FgSelect,
    ExportModal
  },

  data() {

    return {
      tableColumns: [
        {label: 'Page Name', value: 'page_name', minWidth: '200', align: 'center'},
        {label: 'Page Url', value: 'page_url', minWidth: '200', align: 'center'},
        {label: 'Page Type', value: 'page_type', minWidth: '200', align: 'center'},
        {label: 'Parent Page', value: 'parent.page_name', minWidth: '200', align: 'center'},

      ],
      fixedColumn: null,
      modals: {
        basic: false,
        centered: false,
        custom: false,
        confirm: false
      },
      filterBuilders: {
        pages: []
      },

      filters: {
        page_id: null
      },

      deleteModalVisibility: false,
      toDeleteId: undefined,
      componentKey: 0,
    }
  },
  created() {
    this.responsiveViewPort();
  },
  async mounted() {
    let data = {}
    let response = await this.axios.post("pages/builder", data);
    this.filterBuilders.pages = response.data.pageList;
  },

  methods: {

    openDeleteModal(id) {
      this.deleteModalVisibility = true;
      this.toDeleteId = id;
    },

    closeDeleteModal() {
      this.deleteModalVisibility = false;
    },

    async confirmDeleteModal() {
      try {
        let data = {
          'id': this.toDeleteId,
        }
        await this.axios.delete("pages/delete", {headers: {}, data});
        this.$refs.table.getData("updateData");
        this.$notify({
          message: "Page deleted successfully",
          timeout: 1000,
          type: 'success'
        });
      } catch (error) {
        this.$notify({
          message: error.response.data.message,
          timeout: 2000,
          type: 'danger'
        })
      } finally {
        this.closeDeleteModal();
        this.toDeleteId = undefined;
      }
    },

    async reorder(data) {
      try {
        let body = {};
        let orderData = [];
        data.forEach((row, i) => {
          orderData.push({"id": row.id, "sort_order": i + 1})
        });
        body = {
          data: orderData,
        }

        await this.axios.post("pages/re-order", body);

        this.$notify({
          message: "order updated successfully",
          timeout: 1000,
          type: 'success'
        });

      } catch (error) {
        this.$notify({
          message: error.response.data.message,
          timeout: 2000,
          type: 'danger'
        })
      }
    },

    applyFilter() {
      this.$refs.table.filters = {...this.filters};
      if (this.filters.page_id) {
        this.$refs.table.createDragAndDropSorting();
      } else {
        this.$refs.table.destroyDragAndDropSorting();
      }
      this.$refs.table.getData("updateData");
    },
    openModal(name) {
      this.modals[name] = true
    },
    closeModal(name) {
      this.modals[name] = false
    },
    responsiveViewPort() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.fixedColumn = null;
      } else {
        this.fixedColumn = 'right';
      }
    }
  }
  ,
}
</script>

